import React from 'react';
import './styles.scss';
import logo from './../../images/logo.svg';

const Logo = ( props ) => {
    return (
        <div className="logo">
            <img src={ logo } alt="" onClick={ () => props.setFunction() } />
        </div>
    )
}

export default Logo;